//
import axios from 'axios'
import { RForm, RTable } from "@/components/reusable_components/next"

//
import PosCashDesk from "@/models/POS/PosCashDesk"
import filters from "./filters"
import headers from "./headers"

//
export default {
  name: "pos-cash-desk-list",
  components: {
    RForm,
    RTable,
  },
  computed: {

    /**
     *
     */
    tableProps() {
      return {
        service: PosCashDesk,
        filters,
        headers,
      }
    },
  },
  data() {
    return {
      selected: null,
    }
  },
  methods: {

    /**
     * 
     */
    error(error) {
      this.$toast.error(Translator(UserModel, error.response.data))
    },

    /**
     * 
     */
    delete() {
      this.selected.delete().then(this.successDelete).then(this.$refs.table.refresh).catch(this.errorDelete);
    },

    /**
     *
     */
    errorDelete(error) {
      this.$toast.error(error.message)
    },

    refresh() {
      this.$refs.table.refresh()
    },

    /**
     *
     */
    submitCreate() {
      this.$router.push({ name: 'pos-cash-desk-create' })
    },

    /**
     *
     */
    submitDelete(event) {
      this.selected = event.item
      this.$toast.confirm("¿Confirma la eliminación de la caja seleccionada?", this.$toaster(this, this.delete))
    },

    /**
     *
     */
    submitUpdate(event) {
      this.$router.push({ name: "pos-cash-desk-update", params: { id: event.item.id } })
    },

    /**
     * 
     */
    successDelete() {
      this.$toast.success("Caja eliminada exitosamente.")
    },
  },
  beforeMount() {
    this.setTitle('Cajas')
    this.setItems([
      {
        action: this.submitCreate,
        color: 'accent',
        icon: 'add_circle',
        text: 'crear caja',
      }
    ])
  },
}